import { Helmet } from 'react-helmet-async';

export function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-gray-950 text-yellow-100">
      <Helmet>
        <title>Terms of Use | PropViper</title>
        <meta name="description" content="Read the terms of use for PropViper.com, including disclaimers, user responsibilities, and legal notices." />
      </Helmet>

      <section className="bg-gradient-to-br from-black to-gray-900 py-16 sm:py-20 text-center px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 text-yellow-400">Terms of Use</h1>
          <p className="text-base sm:text-lg text-yellow-200">Last updated: April 9, 2025</p>
        </div>
      </section>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-16 space-y-10 text-yellow-100 text-base leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing and using PropViper.com, you agree to be bound by these Terms of Use and all applicable laws and regulations.
            If you do not agree with any of these terms, you are prohibited from using or accessing this site.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">2. Disclaimer</h2>
          <p>
            All information on PropViper is provided for educational and informational purposes only. We are not financial advisors.
            Prop trading involves risk, and users should perform their own due diligence before making any decisions.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">3. Affiliate Disclosure</h2>
          <p>
            Some links on this site may be affiliate links. This means we may earn a commission at no extra cost to you if you sign up
            or purchase through those links. This helps support the site and our content creation.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">4. Intellectual Property</h2>
          <p>
            All content, branding, and visuals on PropViper.com are the intellectual property of the site owner unless stated otherwise.
            You may not reproduce, modify, or republish any part of the site without permission.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">5. Limitation of Liability</h2>
          <p>
            PropViper shall not be held liable for any losses or damages arising from the use of this website or the services of third-party firms linked through our site.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">6. Changes to Terms</h2>
          <p>
            We may update these Terms of Use at any time. Users are encouraged to review this page regularly to stay informed of any changes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-yellow-300 mb-4">7. Contact</h2>
          <p>
            If you have any questions about these Terms, you can contact us via email at <a href="mailto:support@propviper.com" className="text-yellow-400 underline">support@propviper.com</a>.
          </p>
        </section>
      </main>
    </div>
  );
}
